webpackJsonp([79438531329954],{

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/plans-bg.659d3626.png";

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FunnelTitle = exports.Funnel = undefined;
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Funnel = (0, _glamorous2.default)(_Section2.default)(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme,
	      _ref$glam = _ref.glam,
	      glam = _ref$glam === undefined ? {} : _ref$glam;
	  return _ref2 = {
	    background: "linear-gradient(to right, #243B55, #141E30)",
	    color: "white",
	    display: "flex",
	    flexDirection: glam.flexDirection || "row"
	  }, _ref2[theme.main.mediaQueries.mobileTablet] = {
	    flexDirection: "column",
	    textAlign: "center",
	    "&> *:not(:last-child)": {
	      marginBottom: "1.5rem",
	      padding: 0
	    }
	  }, _ref2;
	});
	
	var FunnelTitle = _glamorous2.default.h1({
	  color: "#fff",
	  margin: 0
	});
	
	exports.Funnel = Funnel;
	exports.FunnelTitle = FunnelTitle;

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Hero = __webpack_require__(65);
	
	var _Funnel = __webpack_require__(48);
	
	var _FeatureButton = __webpack_require__(32);
	
	var _FeatureButton2 = _interopRequireDefault(_FeatureButton);
	
	var _FeatureIcons = __webpack_require__(47);
	
	var Icons = _interopRequireWildcard(_FeatureIcons);
	
	var _plansBg = __webpack_require__(673);
	
	var _plansBg2 = _interopRequireDefault(_plansBg);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = _glamorous2.default.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    alignItems: "center",
	    display: "flex",
	    flexDirection: "column",
	    justifyContent: "center",
	    padding: "4.5rem 1.0875rem",
	    ":nth-child(even):not(.funnel,.integration)": {
	      background: theme.main.colors.light
	    }
	  };
	});
	
	var PlanDescription = _glamorous2.default.div(function (_ref2) {
	  var _ref3;
	
	  var theme = _ref2.theme;
	  return _ref3 = {
	    margin: "auto 3rem auto 0",
	    width: "40%"
	  }, _ref3[theme.main.mediaQueries.mobile] = {
	    textAlign: "center",
	    width: "90%"
	  }, _ref3;
	});
	
	var PlanFeatures = _glamorous2.default.div(function (_ref4) {
	  var _ref5;
	
	  var theme = _ref4.theme;
	  return _ref5 = {
	    display: "flex",
	    flexWrap: "wrap",
	    justifyContent: "space-between",
	    width: "60%"
	  }, _ref5[theme.main.mediaQueries.mobile] = {
	    width: "100%"
	  }, _ref5;
	});
	
	var Feature = _glamorous2.default.div({
	  alignItems: "center",
	  display: "flex",
	  padding: "1rem 0",
	  fontWeight: 800,
	  width: "45%",
	  "& div": {
	    textAlign: "center",
	    width: "80%"
	  }
	});
	
	var EmailLink = _glamorous2.default.a({
	  color: "#fff",
	  display: "block",
	  textDecoration: "none",
	  textUnderlinePosition: "under",
	  marginLeft: "3rem",
	  ":hover": {
	    textDecoration: "underline"
	  }
	});
	
	var NarrowContainer = _glamorous2.default.div(function (_ref6) {
	  var _ref7;
	
	  var theme = _ref6.theme;
	  return _ref7 = {
	    display: "flex",
	    maxWidth: theme.main.maxWidths.default * 0.75
	  }, _ref7[theme.main.mediaQueries.mobile] = {
	    flexDirection: "column"
	  }, _ref7;
	});
	
	var PlansPage = function PlansPage(_ref8) {
	  var onToggleContactForm = _ref8.onToggleContactForm;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Hero.Hero,
	      { glam: { background: "#1e485f url('" + _plansBg2.default + "') repeat center" } },
	      _react2.default.createElement(
	        _Hero.HeroTitle,
	        { color: "#fff" },
	        "A plan fit for you"
	      ),
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          _glamorous2.default.P,
	          { fontSize: "24px", color: "#fff", textAlign: "center" },
	          "Manta Equipment is just getting started, and we are dedicated to building a platform that suits you. Get a solution tailored to your needs."
	        )
	      ),
	      _react2.default.createElement(
	        _FeatureButton2.default,
	        { onClick: onToggleContactForm },
	        "Arrange a Demo"
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(
	          PlanDescription,
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "The custom plan"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Instead of having to fit into predefined plans, just let us know what features you need and we'll make it happen."
	          ),
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Live support, unlimited users, premium service."
	          )
	        ),
	        _react2.default.createElement(
	          PlanFeatures,
	          null,
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.OnDemandSupport, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "On-demand support"
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.ImportExport, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Import and export"
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.CustomAdditions, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Custom additions"
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.UnlimitedDepartments, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Unlimited departments"
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.BatteriesIncluded, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Batteries included"
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.FullControl, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              "Full control"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Funnel.Funnel,
	      { css: { flexDirection: "column" } },
	      _react2.default.createElement(
	        _Funnel.FunnelTitle,
	        { css: { marginBottom: "1rem" } },
	        "Get in touch"
	      ),
	      _react2.default.createElement(
	        _glamorous2.default.Div,
	        { display: "flex", justifyContent: "space-between", alignItems: "center" },
	        _react2.default.createElement(
	          _FeatureButton2.default,
	          { href: "https://m.me/MantaEquipment?ref=plans" },
	          _react2.default.createElement(Icons.Messenger, null),
	          _react2.default.createElement(
	            "span",
	            null,
	            "Talk to us on Messenger"
	          )
	        ),
	        _react2.default.createElement(
	          EmailLink,
	          { href: "#", onClick: onToggleContactForm },
	          "Send us an email"
	        )
	      )
	    )
	  );
	};
	
	exports.default = PlansPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-plans-js-174615ca17b7d6c6e9c8.js